import React from "react";
// import NavbarBackButton from "./BackButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import NavbarBackButton from "./BackButton";

function Navbar({ ...props }) {
    let navigate = useNavigate();
    const onExit = () =>{
        navigate("/exit")
        localStorage.clear();
    }
  return (
    <nav className="single-navbar background-pink py-1" role="navigation" aria-label="main navigation">
        <NavbarBackButton title={props.title}/>
        <div>
                <strong className="is-size-5 has-text-white">
                    {props.title !== undefined && props.title.length > 22 ? props.title.substring(0, 20) + "..." : props.title}
                </strong>
        </div>
        <div style={{fontSize: "25px"}}>
          <FontAwesomeIcon icon={faTimesCircle} onClick={() => onExit()}/>
        </div>
    </nav>
  );
}
export default Navbar;
